export default "__VITE_ASSET__ChML3BEb__"